import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useAppNudgeStore } from "@faire/retailer-visitor-shared/features/Nudges/useAppNudgeStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { useMutation as useDismissReferralAdoptionNudge } from "@faire/web-api--source/api/brand-referrals/retailer/retailerToken/dismiss-referral-nudges/post-hooks";
import { useQuery as useReferralNudgesQuery } from "@faire/web-api--source/api/brand-referrals/retailer/retailerToken/referral-nudges/get-hooks";
import { route as boardsRoute } from "@faire/web-api--source/routes/boards";
import { route as brandPageRoute } from "@faire/web-api--source/routes/brand/brandToken";
import { route as categoryRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import { route as saleRoute } from "@faire/web-api--source/routes/flash-sale";
import { route as myBrandsRoute } from "@faire/web-api--source/routes/my-brands";
import { route as myReviewsRoute } from "@faire/web-api--source/routes/my-reviews";
import { route as productRoute } from "@faire/web-api--source/routes/product/productToken";
import { route as homeRoute } from "@faire/web-api--source/routes/root";
import { route as searchRoute } from "@faire/web-api--source/routes/search";
import { matchPath } from "react-router-dom";
var ELIGIBLE_PAGES = [
    homeRoute,
    searchRoute,
    categoryRoute,
    brandPageRoute,
    productRoute,
    boardsRoute,
    myBrandsRoute,
    myReviewsRoute,
    saleRoute
];
export var isPathEligibleForReferralAdoptionNudges = function(pathName) {
    var currentPathName = pathName !== null && pathName !== void 0 ? pathName : getCurrentPath().pathname;
    return !!ELIGIBLE_PAGES.find(function(whitelistPage) {
        return matchPath(currentPathName, {
            path: whitelistPage,
            exact: true
        });
    });
};
export var useReferralAdoptionNudgeEligibility = function() {
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var _useAppNudgeStore = _sliced_to_array(useAppNudgeStore([
        "hasAcknowledgedReferralAdoptionNudge"
    ]), 2), hasAcknowledgedReferralAdoptionNudge = _useAppNudgeStore[0].hasAcknowledgedReferralAdoptionNudge, setAppNudgeStore = _useAppNudgeStore[1];
    var _useDismissReferralAdoptionNudge = useDismissReferralAdoptionNudge(), dismissNudge = _useDismissReferralAdoptionNudge.mutateAsync;
    var _useReferralNudgesQuery = useReferralNudgesQuery(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", {
        enabled: !!retailerToken
    }), nudgesData = _useReferralNudgesQuery.data;
    var shouldShowReferralAdoptionNudge = !hasAcknowledgedReferralAdoptionNudge && nudgesData && (nudgesData === null || nudgesData === void 0 ? void 0 : nudgesData.r2b_nudge_type) && nudgesData.r2b_nudge_type !== "R2B_NUDGE_TYPE_UNKNOWN";
    return {
        shouldShowReferralAdoptionNudge: shouldShowReferralAdoptionNudge,
        nudges: nudgesData,
        nudgeVersion: nudgesData === null || nudgesData === void 0 ? void 0 : nudgesData.nudge_version,
        nudgeType: nudgesData === null || nudgesData === void 0 ? void 0 : nudgesData.r2b_nudge_type,
        nudgeData: nudgesData && getNudgeDataForType(nudgesData),
        setAppNudgeStore: setAppNudgeStore,
        dismissNudge: dismissNudge,
        hasAcknowledgedReferralAdoptionNudge: hasAcknowledgedReferralAdoptionNudge
    };
};
var getNudgeDataForType = function(nudges) {
    switch(nudges.r2b_nudge_type){
        case "BRAND_ACTIVATION":
            return nudges.brand_activation_data;
        case "EMPTY_SEARCH":
            return nudges.empty_search_data;
        case "R2B_INTRO":
            return nudges.r2b_intro_data;
        case "R2B_NUDGE_TYPE_UNKNOWN":
        default:
            return undefined;
    }
};
